import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup
} from '@angular/forms';
import { Subject } from 'rxjs';
import Employee from 'src/app/model/product/employee';
import DateHelper from 'src/app/helpers/date-helper';
import UserHelper from 'src/app/helpers/user-helper';

@Component({
  selector: 'yes-no',
  templateUrl: './yes-no.component.html',
  styleUrls: ['./yes-no.component.scss']
})
export class YesNoComponent implements OnInit, OnChanges {
  showInstructionOn: boolean;
  showAlways = false;
  formGroup: UntypedFormGroup;
  @Input()
  public title: string;
  @Input()
  public subtitle: string;
  @Input()
  public yesValue = 'Ja';
  @Input()
  public noValue = 'Nee';
  @Input()
  public extraInstructions = 'Geef hier extra uitleg';
  @Input()
  public extraInstructionsTitle: string;
  @Input()
  public showExtraInstructionsOn = 'Ja';
  @Input()
  public alwaysShowExtraInstructions = false;
  @Input()
  public neverShowExtraInstructions = false;
  @Input()
  public inputText: string;
  @Input()
  public sensitiveText: boolean = false;
  @Input()
  public value = false;
  @Input()
  public flexRow = true;
  @Input()
  public yesFirst = true;
  @Input()
  public nullIsFalse = true;
  @Input()
  public answerChange: Subject<boolean>;
  @Input()
  public answeredTextChange: Subject<string>;
  @Input()
  public disabled = false;
  @Input()
  public disabledYes = false;
  @Input()
  public tooltipYes: string;
  @Input()
  public disabledNo = false;
  @Input()
  public tooltipNo: string;
  @Input()
  public client = false;
  @Input()
  public done: boolean = null;
  @Input()
  public withHorizontalCheckbox = false;
  @Input()
  public horizontalCheckboxBoolean: boolean = null;
  @Input()
  public horizontalCheckboxLabel: string = null;
  @Input()
  public toShowDateLabel: string = null;
  @Input()
  public toShowASAP: boolean = null;
  @Input()
  public toShowDate: Date = null;
  @Input()
  public toShowEmployee: Employee;
  @Input()
  public showBoolean = false;
  @Input()
  public toShowBoolean: boolean = null;
  @Input()
  public nullable = false;
  @Output()
  public answer = new EventEmitter<boolean>();
  @Output()
  public answeredText = new EventEmitter<string>();
  @Output()
  public doneAnswered = new EventEmitter<string>();
  @Output()
  public horizontalCheckboxAnswered = new EventEmitter<boolean>();

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit() {
    this.formGroup = this.initYesNoForm();
    if (this.showExtraInstructionsOn !== null) {
      this.showInstructionOn = this.showExtraInstructionsOn === this.yesValue;
    } else {
      this.showInstructionOn = null;
    }
    if (this.answerChange != null) {
      this.answerChange.subscribe(b => {
        this.value = b;
      });
    }
    if (this.disabled) {
      this.formGroup.controls['answer'].disable();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.formGroup == null) {
      return;
    }
    if (changes.disabled) {
      if (changes.disabled.currentValue === true) {
        this.formGroup.controls['answer'].disable();
      } else {
        this.formGroup.controls['answer'].enable();
      }
    }
  }

  initYesNoForm() {
    return this.formBuilder.group({
      answer: new UntypedFormControl('')
    });
  }

  answered(value) {
    this.value = value === this.yesValue;
    this.answer.emit(this.value);
  }

  answeredYes(value) {
    this.answeredText.emit(value);
  }

  answeredDone(value) {
    this.doneAnswered.emit(value);
  }

  answeredHorizontalCheckbox(value) {
    this.horizontalCheckboxAnswered.emit(value);
  }

  resetValue() {
    this.value = null;
    this.answer.emit(this.value);
  }

  anyToShowDefined() {
    return (
      this.toShowDate != null ||
      this.toShowASAP != null ||
      this.toShowEmployee != null ||
      this.showBoolean
    );
  }

  dateDefined() {
    return this.toShowDate != null || this.toShowASAP != null;
  }

  printToShowDate() {
    return DateHelper.formatDate(this.toShowDate);
  }

  showCommaAfterDate() {
    return this.toShowEmployee != null || this.showBoolean;
  }

  getEmployeeLetters() {
    return UserHelper.getLettres(this.toShowEmployee.user);
  }

  getEmployeeName() {
    return UserHelper.getName(this.toShowEmployee.user);
  }

  showCommaAfterEmployee() {
    return this.showBoolean;
  }
}
